import { createContext } from 'react';

import { useCurrentUserQuery } from '../../features/user/hooks/use-query/cdm-use-current-user-query';
import { useInfieldLogout } from '../../hooks/use-infield-logout';

export interface CdmCurrentUserProviderContextInterface {
  useInfieldLogout: () => {
    logout: () => void;
  };
  useCurrentUserQuery: typeof useCurrentUserQuery;
}

const defaultValue: CdmCurrentUserProviderContextInterface = {
  useInfieldLogout,
  useCurrentUserQuery,
};

export const CdmCurrentUserProviderContext =
  createContext<CdmCurrentUserProviderContextInterface>(defaultValue);
